import {
  Paper,
  TableBody,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { getAllStudentProfiles } from "../../../API/student-mgmt";
import { ERROR_TOAST } from "../../../helpers/toasters";
import "./addBatchStudents.css";
import { calculateAge } from "../../../helpers/utils";

export default function AddBatchStudents(props: any) {
  const [studentRows, setStudentRows] = useState<any[]>([]);
  const [selected, setSelected] = useState<string[]>(props.rows || []);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState([]);
  const [all, setAll] = useState(false);

  useEffect(() => {
    getFirstData();
  }, []);

  const getFirstData = async () => {
    setLoading(true);
    try {
      const data = await getAllStudentProfiles();
      if (!data) {
        setStudentRows([]);
        ERROR_TOAST("Error connecting to server!");
      } else {
        setStudentRows(data);
      }
    } catch (e) {
      ERROR_TOAST("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const filteredStudents = studentRows.filter((student) =>
    student.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    student.courses.some((course: any) =>
      course.name.toLowerCase().includes(searchQuery.toLowerCase())
    ) ||
    student.roll_no?.toString().includes(searchQuery)
  );

  return (
    <div className="addBatchStudents">
      <div className="fullBatchDesc">
        <div className="headerACoach">
          <h2>Add Student</h2>
          <div
            className="top-svg"
            onClick={props.handelClose}
            style={{ cursor: "pointer" }}
          >
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
              <path
                d="M15 0C18.9782 0 22.7936 1.58035 25.6066 4.3934C28.4196 7.20644 30 11.0218 30 15C30 18.9782 28.4196 22.7936 25.6066 25.6066C22.7936 28.4196 18.9782 30 15 30C11.0218 30 7.20644 28.4196 4.3934 25.6066C1.58035 22.7936 0 18.9782 0 15C0 11.0218 1.58035 7.20644 4.3934 4.3934C7.20644 1.58035 11.0218 0 15 0ZM15 13.1807L11.5157 9.69643C11.2745 9.45518 10.9473 9.31964 10.6061 9.31964C10.2649 9.31964 9.93768 9.45518 9.69643 9.69643C9.45518 9.93768 9.31964 10.2649 9.31964 10.6061C9.31964 10.9473 9.45518 11.2745 9.69643 11.5157L13.1807 15L9.69643 18.4843C9.45518 18.7255 9.31964 19.0527 9.31964 19.3939C9.31964 19.7351 9.45518 20.0623 9.69643 20.3036C9.93768 20.5448 10.2649 20.6804 10.6061 20.6804C10.9473 20.6804 11.2745 20.5448 11.5157 20.3036L15 16.8193L18.4843 20.3036C18.7255 20.5448 19.0527 20.6804 19.3939 20.6804C19.7351 20.6804 20.0623 20.5448 20.3036 20.3036C20.5448 20.0623 20.6804 19.7351 20.6804 19.3939C20.6804 19.0527 20.5448 18.7255 20.3036 18.4843L16.8193 15L20.3036 11.5157C20.5448 11.2745 20.6804 10.9473 20.6804 10.6061C20.6804 10.2649 20.5448 9.93768 20.3036 9.69643C20.0623 9.45518 19.7351 9.31964 19.3939 9.31964C19.0527 9.31964 18.7255 9.45518 18.4843 9.69643L15 13.1807Z"
                fill="#8E8EA1"
              />
            </svg>
          </div>
        </div>
        <div className="batch-student-border-top"></div>
        <div className="acoach-body">
          <div className="first-drop-batch">
            <div className="header">
              <input
                className="dashboard-search"
                style={{
                  width: "100%",
                  borderWidth: "1px",
                  borderColor: "#C9C9D9",
                  background: "transparent",
                }}
                type="search"
                placeholder="Search student..."
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
            <div className="table-for-batch-students">
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 610 }} aria-label="student table">
                  <TableHead>
                    <TableRow className="table-head-dashboard">
                      <TableCell align="left">Roll Number</TableCell>
                      <TableCell>Student Name</TableCell>
                      <TableCell align="left">Courses</TableCell>
                      <TableCell align="left">Gender</TableCell>
                      <TableCell align="left">Age</TableCell>
                      <TableCell padding="checkbox">
                        {/* <Checkbox
                          onChange={onSelectAllClick}
                          sx={{
                            color: "#B9B9D6",
                            "&.Mui-checked": {
                              color: "#EF1456",
                            },
                          }}
                          inputProps={{
                            "aria-label": "select all students",
                          }}
                        /> */}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredStudents.map((m) => (m.isActive && (

                      <TableRow
                        key={m._id}
                        style={
                          selected.includes(m._id)
                            ? { background: "#F2FBFF" }
                            : {}
                        }
                      >
                        <TableCell align="left">{m.roll_no || "N/A"}</TableCell>
                        <TableCell align="left">{m.name}</TableCell>

                        <TableCell align="left">
                          {m.courses && m.courses.length > 0
                            ? m.courses.map((course: any) => course.name).join(", ")
                            : "No courses"}
                        </TableCell>
                        <TableCell align="left">{m.gender}</TableCell>
                        <TableCell align="left">{calculateAge(m.dob).toString() + " Yrs"}</TableCell>
                        <TableCell padding="checkbox">
                          <Checkbox
                            value={m._id}
                            defaultChecked={
                              props.rows.indexOf(m._id) !== -1 ? true : false
                            }
                            key={m._id}
                            onChange={props.onSelect}
                            sx={{
                              color: "#B9B9D6",

                              "&.Mui-checked": {
                                color: "#EF1456",
                              },
                            }}
                            inputProps={{
                              "aria-label": "select one",
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    )))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
        <div className="down-buttons d-flex">
          <button className="create-button" onClick={props.handelSubmitPre}>
            Add Student
          </button>
          <button className="cancel-button" onClick={props.handelClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
